import { VoyageRoute } from '../../models/voyage-routing-model';
import { ZoneFeature } from "../../models/zones-base-interfaces";
import { ZonesUtilitiesBase } from "./zones-utilities-base";
import { EcaSecaMarpolModel } from "../../models/eca-seca-marpol-zones-model";

export class EcaSecaAreasUtilities extends ZonesUtilitiesBase {
    zoneID: string = "ECA/SECA"
    
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await EcaSecaMarpolModel!.getEcaSecaZones();
        if (!zones) {
            throw new Error("Could not retreive ECA/SECA areas.");
        }

        return zones;
    }
}
